<template>
  <modal :show-close="modalConfig.showClose"
         :wrapper-classes="modalConfig.wrapperClasses"
         @close="closeModal()">
    <h2 slot="header">
      select notification image
    </h2>
    <h3 slot="subHeader">
      select from our library of pre-optimized notification images that will send with your text message
    </h3>
    <div slot="body" class="modal-body">
      <template v-if="customNotificationImages.length === 0 && suggestedNotificationImages.length === 0">
        <span class="notice">you have no notification images available</span>
      </template>
      <template v-else>
        <div class="notification-image-preview">
          <img v-if="previewSelectedImage" :src="previewSelectedImage.attachment.url" alt="notification image preview"/>
        </div>
        <div  class="image-collection-wrapper" style="margin-bottom:15px;">
          <div class="image-collection" v-if="customNotificationImages.length > 0">
            <div class="library-label">custom</div>
            <div class="image-row">
              <div class="image" v-for="(customImage, index) in customNotificationImages"
                                :key="index"
                                :class="{selected: previewSelectedImage && customImage.id === previewSelectedImage.id}">
                <img :src="customImage.attachment.thumb"
                    class="thumbnail"
                    @click="clickedOnThumbnail(customImage)"/>
              </div>
            </div>
          </div>
          <div v-if="suggestedNotificationImages.length > 0" class="image-collection">
            <div class="library-label">suggested</div>
            <div class="image-row">
              <div class="image" v-for="(suggestedImage, index) in suggestedNotificationImages"
                                :key="index"
                                :class="{selected: previewSelectedImage && suggestedImage.id === previewSelectedImage.id}">
                <img :src="suggestedImage.attachment.thumb"
                    class="thumbnail"
                    @click="clickedOnThumbnail(suggestedImage)"/>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div slot="action" class="modal-action-click">
      <button class="button larger include-image-button" :disabled="previewSelectedImage === null" @click="clickedIncludeImage()" data-cy="notification-images-include-image-button">include this image</button>
    </div>
  </modal>
</template>

<script>
  import Modal from "../../components/shared/Modal.vue"
  import {campaignAPI} from "../../services/api/campaignAPI.js"

  export default {
    props: {
      customNotificationImages: Array,
      suggestedNotificationImages: Array
    },

    name: "NotificationImagesModal",

    components: {
      Modal
    },

    data() {
      return {
        modalConfig: {
          showClose: true,
          wrapperClasses: "notification-images-modal"
        },
        previewSelectedImage: null
      }
    },

    created() {
      if(this.customNotificationImages.length > 0) {
        this.previewSelectedImage = this.customNotificationImages[0]
      }else{
        if(this.suggestedNotificationImages.length > 0) {
          this.previewSelectedImage = this.suggestedNotificationImages[0]
        }
      }
    },

    methods: {
      closeModal() {
        this.$emit("hideModalAndRemoveSelectedNotificationImage")
      },
      clickedOnThumbnail(image) {
        this.previewSelectedImage = image
      },
      clickedIncludeImage() {
        this.$emit("updateSelectedNotificationImage", this.previewSelectedImage)
        this.$emit("hideModalAndRemoveSelectedNotificationImage", false)
      },
    }
  }
</script>

<style scoped>
.notification-images-modal h2 {
  font-family: "AileronThin";
  font-size: 1.5em;
  font-weight: bold;
}
.notification-images-modal h3 {
  font-size: 1em;
}
.notification-images-modal .modal-body {
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  min-height: 400px;
  padding: 0 1.5em;
}
.notification-images-modal  .include-image-button {
  font-family: "AileronThin";
}
.notification-images-modal .notice {
  font-size: 1.5em;
  width: 200px;
}
.notification-images-modal .notification-image-preview {
  height: 350px;
  width: 350px;
}
.notification-images-modal .notification-image-preview img {
  border-radius: 6px;
  border: 1px solid #128ff9;
  max-height: 350px;
  object-fit: contain;
  width: auto;
}
.notification-images-modal .image-collection-wrapper {
  margin: 0 auto;
  width: 486px;
}
.notification-images-modal .image-collection {
  align-items: start;
  align-self: start;
  display: flex;
  flex-flow: column wrap;
}
.notification-images-modal .image-collection .library-label {
  font-size: 0.83em;
  padding: 5px 0;
}
.notification-images-modal .image-row {
  display: flex;
  flex-wrap: wrap;
}
.notification-images-modal .image {
  border-bottom-width: 1px;
  border-color: #128ff9;
  border-left-width: 0px;
  border-right-width: 1px;
  border-style: solid;
  border-top-width: 1px;
  cursor: pointer;
  flex-basis: 81px;
  overflow: hidden;
  position: relative;
}
.notification-images-modal .image:first-child {
  border-left-width: 1px;
}
.notification-images-modal .thumbnail {
  border: none;
  height: auto;
}
.notification-images-modal .modal-action-click {
  margin-top: 25px;
}
.notification-images-modal .selected::before{
  border: 3px solid #128ff9;
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  width: 100%;
}
</style>